import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import {
    FAILURE_FETCH_MAIL_TEMPLATES,
    FAILURE_FETCH_PREVIEW_OF_MAIL_TEMPLATE,
    FAILURE_SEND_MAIL_PREVIEW_TO_RECEIVER,
    REQUEST_MAIL_TEMPLATES,
    REQUEST_PREVIEW_OF_MAIL_TEMPLATE,
    REQUEST_SEND_MAIL_PREVIEW_TO_RECEIVER,
    SUCCESS_FETCH_MAIL_TEMPLATES,
    SUCCESS_FETCH_PREVIEW_OF_MAIL_TEMPLATE,
    SUCCESS_SEND_MAIL_PREVIEW_TO_RECEIVER,
} from './actions';

export function mailTemplateReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_MAIL_TEMPLATES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_MAIL_TEMPLATES:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_FETCH_MAIL_TEMPLATES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function mailPreviewReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_PREVIEW_OF_MAIL_TEMPLATE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_PREVIEW_OF_MAIL_TEMPLATE:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_PREVIEW_OF_MAIL_TEMPLATE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_SEND_MAIL_PREVIEW_TO_RECEIVER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SEND_MAIL_PREVIEW_TO_RECEIVER:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_SEND_MAIL_PREVIEW_TO_RECEIVER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
